<div class="cb-file-input-container" [class.cb-required]="required()">
  @if(label()){
  <label>{{label()}}</label>
  }
  <input type="file" #inputFile style="display: none;" [attr.accept]="accept()" [multiple]="multiple()"
    (change)="onFileChange($event)" />

  @if(showDropArea()){
  <div class="cb-file-input-area" [class.cb-dragging]="draggingCount()>0" (drop)="onDrop($event)"
    (dragover)="$event.preventDefault()" (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)">
    <div class="cb-file-input-button">
      <cb-button (click)="onButtonClick($event)" hierarchy="secondary" color="gray" type="iconOnly"
        icon="cb-base-outline-upload"></cb-button>
    </div>

    <div class="cb-file-input-label">
      <p>{{placeholder() || ('COMMON.CLICK_DRAG_TO_UPLOAD' | translate)}}</p>
      @if(imagePlaceholder1.length>0){
      <span>{{imagePlaceholder1()}}</span>
      }
      @if(imagePlaceholder2.length>0){
      <span>{{imagePlaceholder2()}}</span>
      }
    </div>

    <div class="cb-file-drag-label">
      <cb-icon name="cb-base-outline-arrow-circle-down"></cb-icon>
      <p>{{"COMMON.DROP_FILE" | translate}}</p>
    </div>
  </div>
  }

  @if(selectionError() && selectionError().length>0){
  <div class="cb-files-error">
    <p>{{errorsMap[selectionError()] ? (errorsMap[selectionError()] | translate:errorData()) : selectionError() }}</p>
    <cb-icon (click)="selectionError.set('')" name="cb-base-outline-close"></cb-icon>
  </div>
  }
  @if(error() && error()!.length>0){
  <div class="cb-files-error">
    <p>{{ error() }}</p>
  </div>
  }

  <div class="cb-files-list">
    <!-- UPLOADED FILES -->
    @for (file of files; track $index) {
    <ng-container *ngTemplateOutlet="FilePreviewTemplate; context:{file: file}"></ng-container>
    }
    <!-- TO UPLOAD FILES -->
    @for (file of toUploadFiles(); track $index) {
    <ng-container *ngTemplateOutlet="FilePreviewTemplate; context:{file: file, toUpload: true}"></ng-container>
    }
    <!-- NEW UPLOADING FILES -->
    @for (file of uploadingFiles(); track $index) {
    <ng-container
      *ngTemplateOutlet="FilePreviewTemplate; context:{file: file, progress: file.progress?.value}"></ng-container>
    }
  </div>
</div>

<ng-template #FilePreviewTemplate let-file="file" let-progress="progress" let-toUpload="toUpload">
  @if(file){
  <div class="cb-file">
    <div class="cb-file-image">
      <cb-filetype-icon color="brand" type="solid" [filetype]="file.type"></cb-filetype-icon>
    </div>
    <div class="cb-file-info">
      <div class="cb-file-header">
        <p>{{file.name || file.url || file}}</p>

        <div class="cb-file-action">
          @if(progress!=undefined){
          <cb-loader></cb-loader>
          }@else {
          <cb-icon class="cb-delete-icon" name="cb-base-outline-trash" (click)="removeFile(file)"></cb-icon>

          @if(!toUpload && file.url){
          <cb-icon name="cb-base-outline-arrow-topright" (click)="open(file.url)"></cb-icon>
          }
          }
        </div>
      </div>
      <div class="cb-file-additional">
        <p>{{file.size}}</p>
      </div>

      @if(progress!=undefined){
      <div class="cb-file-progress-container">
        <div class="cb-file-progress">
          <div class="cb-file-current-progress" [style.width.%]="progress"></div>
        </div>
        <p>{{progress}} %</p>
      </div>
      }
    </div>
  </div>
  }
</ng-template>